import CouponModal from './CouponModal'

export default CouponModal
